import React, { useEffect } from "react"
import { JackpotWinStyles } from "./WinNotificationStyles"
import { Cube } from "../../../modals/jackpot/header/ItemStyled"
import typeOfJackpots from "../../../modals/jackpot/main/grid/data"

const JackpotWin = ({ jackpotInfo }: any) => {
  const cube =
    jackpotInfo.wintype === 1
      ? "solar"
      : jackpotInfo.wintype === 2
      ? "galactical"
      : "stellar"

  const result = typeOfJackpots.find((obj) => {
    return obj.text === cube
  })

  return (
    <JackpotWinStyles
      color={cube == "stellar" ? "red" : cube == "solar" ? "yellow" : "blue"}
    >
      {result && (
        <Cube color={result.color}>
          <img src={result.svg} width="21px" height="24px" />
        </Cube>
      )}
      <span>
        {jackpotInfo.winnername} has won {cube} JACKPOT
      </span>
    </JackpotWinStyles>
  )
}

export default JackpotWin
